export var BusinessUnitInclude = {
    organization: true,
    parentUnit: true,
    children: {
        where: { deleted: false },
        include: {
            children: { where: { deleted: false } },
            locations: { where: { deleted: false } },
            products: { where: { deleted: false } },
            users: { where: { deleted: false } },
        },
    },
    products: {
        where: { deleted: false },
        include: {
            businessUnit: true,
        },
    },
    locations: {
        where: { deleted: false },
        include: {
            responsible: true,
            businessUnit: true,
        },
    },
    users: {
        where: { deleted: false },
        include: {
            role: true,
            businessUnit: true,
        },
    },
};
export var BusinessUnitSelectShallow = {
    id: true,
    title: true,
    key: true,
    ancestorIds: true,
    active: true,
    metadata: true,
    parentUnitId: true,
};
export var ActiveBusinessUnitInclude = {
    organization: true,
    parentUnit: true,
    children: {
        where: {
            deleted: false,
            active: true,
        },
        include: {
            children: { where: { deleted: false } },
            locations: { where: { deleted: false } },
            products: { where: { deleted: false } },
            users: { where: { deleted: false } },
        },
    },
    products: {
        where: { deleted: false },
        include: {
            businessUnit: true,
        },
    },
    locations: {
        where: { deleted: false },
        include: {
            responsible: true,
            businessUnit: true,
        },
    },
    users: {
        where: { deleted: false },
        include: {
            role: true,
            businessUnit: true,
        },
    },
};
//# sourceMappingURL=BusinessUnit.js.map